import styled from '@emotion/styled';

export const StyledImage = styled.img`
  display: inline-block !important;
  margin: auto;
  height: 100%;
  width: 100%;
  cursor: pointer;
`;
